import { apiRequest } from "./api";
import api from "./api";
import type { Clinic } from "@/types/clinics";

/**
 * GET /clinics/ — list active clinics.
 * Returns [] when feature flag is off (no error handling needed).
 */
export const fetchClinics = (): Promise<Clinic[]> =>
  apiRequest<Clinic[]>(() => api.get("/clinics/"));
